import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Loader } from '../components'

// Sign-up is unified into /login (plan/DECISIONS.md 2026-08-30) — this
// route survives only so old links and CTAs keep working.
const Signup: NextPage = () => {
  const router = useRouter()

  useEffect(() => {
    if (!router.isReady) return
    router.replace({ pathname: '/login', query: router.query })
  }, [router.isReady])

  return (
    <div className="h-screen">
      <Loader />
    </div>
  )
}

export default Signup
